import { useField } from "formik";

function Checkbox({ label, className, disabled, ...props }) {
  const [field, meta] = useField({ ...props, type: "checkbox" });

  return (
    <div
      className={`checkbox-field ${disabled ? "disabled" : ""} ${
        className || ""
      }`}
    >
      <input
        type="checkbox"
        id={props.id || props.name}
        {...field}
        {...props}
        disabled={disabled}
      />

      <div
        className="checkmark"
        onClick={() => {
          if (!disabled) {
            const input = document.getElementById(props.id || props.name);
            if (input) input.click();
          }
        }}
      >
        {field.checked && <span>&#10003;</span>}
      </div>

      {label && <label htmlFor={props.id || props.name}>{label}</label>}

      {meta.touched && meta.error ? (
        <small className="error-msg">{meta.error}</small>
      ) : null}
    </div>
  );
}

export default Checkbox;
